import { GoogleMap, InfoWindow, MarkerF, useJsApiLoader } from '@react-google-maps/api';
import React,{ useState } from 'react';
import { useSelector } from 'react-redux';
import AdvancedMapMarker from './AdvancedMapMarker';
import MapFallback from './MapFallback';

const mapsApiKey = (import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '').trim();
const mapId = (import.meta.env.VITE_GOOGLE_MAPS_MAP_ID || '').trim();
const markerLibraries = ['marker'];
const mapIds = mapId ? [mapId] : undefined;

const defaultContainerStyle = {
    width: '100%',
    height: '100%',
    borderRadius:'10px',
    boxShadow:'0px 0px 10px #f3f6f9'
  };

export default function GoogleMapList(props = {}) {
    if (!mapsApiKey) {
      return <MapFallback message="Map unavailable: Google Maps key is missing." />;
    }

    return <LoadedGoogleMapList {...props} />;
}

function LoadedGoogleMapList({ containerStyle } = {}){
    const eventList=useSelector(state=>state.event.eventList);
    const country=useSelector(state=>state.event.country);
    const [selectedPlace, setSelectedPlace] = useState(null);
    const { isLoaded, loadError } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: mapsApiKey,
        libraries: markerLibraries,
        mapIds,
      });

      let defaultCenter = {
        lat: 39.8283,
        lng: -98.5795
      };
      let defaultZoom = 4;

      if(country == 'Jamaica'){
        defaultCenter = {
          lat: 18.15736419363124,
          lng: -77.4411452138823
        };
        defaultZoom = 8.5;
      }
      
      const markerList = (eventList || [])
        .map((item, index) => {
          const lat = parseFloat(item.latitude);
          const lng = parseFloat(item.longitude);
          if (isNaN(lat) || isNaN(lng)) return null;
          return { id: index + 1, position: { lat, lng }, name: item.name, address: item.venueaddress };
        })
        .filter(Boolean);
      const handleMarkerClick = (marker) => {
        setSelectedPlace(marker);
      };
      const handleInfoWindowClose = () => {
        setSelectedPlace(null);
      };

      if (loadError) {
        return <MapFallback message="Map unavailable: Google Maps could not load." />;
      }

      return isLoaded ? (
          <>
          <div style={{ width: '100%', height: '100%' }}>
          <GoogleMap
        mapContainerStyle={containerStyle || defaultContainerStyle}
        zoom={defaultZoom}
        center={defaultCenter}
        options={mapId ? { mapId } : undefined}
      >
        {markerList && markerList.map(marker => (
          mapId ? (
          <AdvancedMapMarker
            key={marker.id}
            position={marker.position}
            title={marker.name}
            onClick={() => handleMarkerClick(marker)}
            icon="/assets/icons/location.png"
          />
          ) : (
          <MarkerF
            key={marker.id}
            position={marker.position}
            title={marker.name}
            onClick={() => handleMarkerClick(marker)}
            icon="/assets/icons/location.png"
          />
          )
        ))}
        {selectedPlace && (
          <InfoWindow
            position={selectedPlace.position}
            onCloseClick={handleInfoWindowClose}
            style={{padding:'0px'}}
          >
            <div className="info-window-content">
              <h5>{selectedPlace.name}</h5>
              <p>{selectedPlace.address}</p>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
        </div>
        </>
    ) : <MapFallback loading />
}
